import { render, staticRenderFns } from "./MensuracaoProjeto.vue?vue&type=template&id=05bd1a49&scoped=true"
import script from "./MensuracaoProjeto.vue?vue&type=script&lang=js"
export * from "./MensuracaoProjeto.vue?vue&type=script&lang=js"
import style0 from "./MensuracaoProjeto.vue?vue&type=style&index=0&id=05bd1a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd1a49",
  null
  
)

export default component.exports